import CardItem from './CardItem';
import {
  Spinner
} from 'react-bootstrap';

const GalleryPage = (props) => {
  return (
    <div>
      {false ? (
        <div
          style={{
            width: '100%',
            aspectRatio: '32/15',
            padding: '19% 0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
      ) : (
        <div>
        <div className="d-flex flex-nowrap">
        {props.data[0] ? (
          <CardItem data={props.data[0]} />
        ) : (
          <div
            style={{
              width: '33.333333%',
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              padding: '2px',
              cursor: 'pointer',
              aspectRatio: '16/10'
            }}
          />
        )}
        {props.data[1] ? (
          <CardItem data={props.data[1]} />
        ) : (
          <div
            style={{
              width: '33.333333%',
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              padding: '2px',
              cursor: 'pointer',
              aspectRatio: '16/10'
            }}
          />
        )}
        {props.data[2] ? (
          <CardItem data={props.data[2]} />
        ) : (
          <div
            style={{
              width: '33.333333%',
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              padding: '2px',
              cursor: 'pointer',
              aspectRatio: '16/10'
            }}
          />
        )}
      </div>
      <div className="d-flex flex-nowrap">
        {props.data[3] ? (
          <CardItem data={props.data[3]} />
        ) : (
          <div
            style={{
              width: '33.333333%',
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              padding: '2px',
              cursor: 'pointer',
              aspectRatio: '16/10'
            }}
          />
        )}
        {props.data[4] ? (
          <CardItem data={props.data[4]} />
        ) : (
          <div
            style={{
              width: '33.333333%',
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              padding: '2px',
              cursor: 'pointer',
              aspectRatio: '16/10'
            }}
          />
        )}
        {props.data[5] ? (
          <CardItem data={props.data[5]} />
        ) : (
          <div
            style={{
              width: '33.333333%',
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              padding: '2px',
              cursor: 'pointer',
              aspectRatio: '16/10'
            }}
          />
        )}
      </div>
      <div className="d-flex flex-nowrap">
        {props.data[6] ? (
          <CardItem data={props.data[6]} />
        ) : (
          <div
            style={{
              width: '33.333333%',
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              padding: '2px',
              cursor: 'pointer',
              aspectRatio: '16/10'
            }}
          />
        )}
        {props.data[7] ? (
          <CardItem data={props.data[7]} />
        ) : (
          <div
            style={{
              width: '33.333333%',
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              padding: '2px',
              cursor: 'pointer',
              aspectRatio: '16/10'
            }}
          />
        )}
        {props.data[8] ? (
          <CardItem data={props.data[8]} />
        ) : (
          <div
            style={{
              width: '33.333333%',
              height: 'auto',
              borderRadius: '10px',
              overflow: 'hidden',
              boxSizing: 'border-box',
              padding: '2px',
              cursor: 'pointer',
              aspectRatio: '16/10'
            }}
          />
        )}
      </div>
        </div>
      )}
      
    </div>
  );
};

export default GalleryPage;
